// Migrated Regista custom JS extracted from previous theme. Licensed Prestige core was not overwritten.
(() => {
  if (window.__registaSleevePickerStateSync) return;
  window.__registaSleevePickerStateSync = true;

  function syncPicker(picker) {
    if (!picker) return;
    picker.querySelectorAll('.regista-sleeve-picker__choice').forEach((choice) => {
      const input = choice.querySelector('input[type="radio"]');
      choice.classList.toggle('is-selected', !!(input && input.checked));
    });
  }

  function syncAll() {
    document.querySelectorAll('.regista-sleeve-picker__panel').forEach(syncPicker);
  }

  document.addEventListener('change', (event) => {
    const picker = event.target && event.target.closest ? event.target.closest('.regista-sleeve-picker__panel') : null;
    if (picker) syncPicker(picker);
  }, true);

  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  syncAll();
})();

// Regista final sleeve proxy: visual buttons control the real Shopify variant dropdown
(() => {
  if (window.__registaFinalSleeveProxy) return;
  window.__registaFinalSleeveProxy = true;

  function cssEscape(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/"/g, '\\"');
  }

  function getNativeInput(fieldset) {
    return fieldset ? fieldset.querySelector('.regista-sleeve-native-listbox input[type="hidden"]') : null;
  }

  function getNativeOption(fieldset, value) {
    if (!fieldset) return null;
    return fieldset.querySelector('.regista-sleeve-native-listbox [role="option"][value="' + cssEscape(value) + '"]');
  }

  function syncSleeveFieldset(fieldset) {
    if (!fieldset) return;
    const input = getNativeInput(fieldset);
    const currentValue = input ? input.value : '';

    fieldset.querySelectorAll('[data-regista-sleeve-proxy-option]').forEach((button) => {
      const value = button.getAttribute('data-regista-sleeve-value') || '';
      const nativeOption = getNativeOption(fieldset, value);
      const selected = value === currentValue;
      const hidden = !!(nativeOption && nativeOption.hasAttribute('hidden'));
      const disabled = !!(nativeOption && nativeOption.classList.contains('is-disabled'));

      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.toggleAttribute('hidden', hidden);
      button.toggleAttribute('disabled', disabled);
    });
  }

  function syncAllSleevePickers() {
    document.querySelectorAll('.regista-sleeve-picker').forEach(syncSleeveFieldset);
  }

  function selectSleeveValue(fieldset, value) {
    const input = getNativeInput(fieldset);
    const nativeOption = getNativeOption(fieldset, value);
    const listbox = fieldset ? fieldset.querySelector('.regista-sleeve-native-listbox') : null;

    if (nativeOption) {
      nativeOption.click();
    } else if (input) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (input && input.value !== value) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    window.setTimeout(() => syncSleeveFieldset(fieldset), 0);
    window.setTimeout(syncAllSleevePickers, 80);
  }

  document.addEventListener('click', (event) => {
    const button = event.target && event.target.closest ? event.target.closest('[data-regista-sleeve-proxy-option]') : null;
    if (!button || button.disabled) return;

    const fieldset = button.closest('.regista-sleeve-picker');
    const value = button.getAttribute('data-regista-sleeve-value') || '';
    if (!fieldset || !value) return;

    event.preventDefault();
    selectSleeveValue(fieldset, value);
  }, true);

  document.addEventListener('change', (event) => {
    const fieldset = event.target && event.target.closest ? event.target.closest('.regista-sleeve-picker') : null;
    if (fieldset) {
      window.setTimeout(() => syncSleeveFieldset(fieldset), 0);
    }
  }, true);

  document.addEventListener('variant:change', () => {
    window.setTimeout(syncAllSleevePickers, 0);
    window.setTimeout(syncAllSleevePickers, 80);
  }, true);

  document.addEventListener('DOMContentLoaded', syncAllSleevePickers);
  document.addEventListener('shopify:section:load', syncAllSleevePickers);
  syncAllSleevePickers();
  window.setTimeout(syncAllSleevePickers, 250);
  window.setTimeout(syncAllSleevePickers, 1000);
})();
